import { getRouterSelectors } from '@ngrx/router-store';
import { toInteger } from 'lodash';

import { createRouterEntitySelectors } from './create-router-entity';

export const {
  selectCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectRouteDataParam, // select the current route data param
  selectUrl, // select the current url
  selectTitle, // select the title if available
} = getRouterSelectors();

export const ClientRouterSelectors = createRouterEntitySelectors({
  routeParam: 'clientId',
  queryParam: 'client',
  parser: integerParser,
});
export const PolicyRouterSelectors = createRouterEntitySelectors({
  routeParam: 'policyId',
  queryParam: 'policy',
  parser: integerParser,
});
export const UserRouterSelectors = createRouterEntitySelectors<string>({
  routeParam: 'userId',
  queryParam: 'user',
});

export const QuoteRouterSelectors = createRouterEntitySelectors({
  routeParam: 'quoteId',
  queryParam: 'quote',
  parser: integerParser,
});

export const ProposalRouterSelectors = createRouterEntitySelectors<string>({
  routeParam: 'proposalId',
  queryParam: 'proposal',
});

export const ProposalDocumentsRouterSelectors =
  createRouterEntitySelectors<string>({
    routeParam: 'proposalDocumentId',
    queryParam: 'document',
  });

export const FolderRouterSelectors = createRouterEntitySelectors({
  routeParam: 'folderId',
  queryParam: 'folder',
  parser: folderParamParser,
});

function folderParamParser(param: string | unknown) {
  return param === 'home' || !param ? undefined : toInteger(param);
}

function integerParser(param: string | unknown) {
  return param ? toInteger(param) : undefined;
}
